import { Switch } from '@material-ui/core'
import { Form, Formik } from 'formik'
import React, { useEffect, useState } from 'react'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import { fetchSettings, updateSettings } from '../../actions/setting/setting'
import { toAbsoluteUrl } from '../../_metronic/_helpers'
import { Card, CardBody, CardHeader, CardHeaderToolbar } from '../../_metronic/_partials/controls'

export default function Setting() {

    const { settings } = useSelector(
        (state) => ({
            settings:
                state.setting && state.setting.settings && state.setting.settings[0],
        }),
        shallowEqual
    );

    const initialValues = {
        in_bc: false,
        in_wix: false,
        in_shopify: false,
        in_venderportal: false,
        in_wp: false,
    }

    const [checked, setChecked] = useState({
        in_bc: false,
        in_wix: false,
        in_shopify: false,
        in_venderportal: false,
        in_wp: false,
    });

    const toggleCheck = (inputName, setFieldValue) => {
        setChecked((prevState) => {
          const newState = { ...prevState };
          newState[inputName] = !prevState[inputName];
          setFieldValue(inputName, !prevState[inputName]);
          dispatch(updateSettings(settings && settings._id, newState))
          return newState;
        });
    };

    const dispatch = useDispatch()
    useEffect(() => {
        const getSettings = async () => {
            await dispatch(fetchSettings())
        }
        getSettings()

    }, [dispatch])

    useEffect(() => {
        if(settings && settings._id){
            setChecked((prevState) => {
                const newState = { ...prevState };
                for (const inputName in newState) {
                  newState[inputName] = settings[inputName];
                }
                return newState;
            });
        }
    }, [settings]);

    return (
        <div>
            <Card>
                <CardHeader title={"Please Select The Platform"}>
                    <CardHeaderToolbar>
                    </CardHeaderToolbar>
                </CardHeader>{" "}
                <CardBody>
                    <Formik
                        enableReinitialize={true}
                        initialValues={settings || initialValues}
                        onSubmit={async (values, { setErrors }) => {
                        }}>
                        {({ handleSubmit, field, setFieldValue, values, handleChange }) => (
                            <>
                                <Form className='form form-label-right'>

                                    <table className="table">
                                        <thead>
                                            <tr>
                                                <th scope="col"></th>
                                                <th scope="col">Logo</th>
                                                <th scope="col" width="300">Platform Name</th>
                                                <th scope="col">Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td></td>
                                                <td><img src={toAbsoluteUrl("/media/platforms/vendorPortal.png")} alt="" title="Vendor Portal" height="32" width="32"></img></td>
                                                <td>Vendor Portal</td>
                                                <td>
                                                    <Switch
                                                        name="in_venderportal"
                                                        checked={checked["in_venderportal"]}
                                                        onChange={() => {
                                                            toggleCheck('in_venderportal', setFieldValue);
                                                        }}
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td></td>
                                                <td><img src={toAbsoluteUrl("/media/platforms/wix.png")} alt="" title="Wix" height="32" width="32"></img></td>
                                                <td>Wix</td>
                                                <td>
                                                    <Switch
                                                        name="in_wix"
                                                        checked={checked["in_wix"]}
                                                        onChange={() => {
                                                            toggleCheck('in_wix', setFieldValue);
                                                        }}
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td></td>
                                                <td><img src={toAbsoluteUrl("/media/platforms/shopify.png")} alt="" title="Shopify" height="32" width="32"></img></td>
                                                <td>Shopify</td>
                                                <td>
                                                    <Switch
                                                        name="in_shopify"
                                                        checked={checked["in_shopify"]}
                                                        onChange={() => {
                                                            toggleCheck('in_shopify', setFieldValue);
                                                        }}
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td></td>
                                                <td><img src={toAbsoluteUrl("/media/platforms/bigcommerce.png")} alt="" title="BigCommerce" height="32" width="32"></img></td>
                                                <td>Bigcommerce</td>
                                                <td>
                                                    <Switch
                                                        name="in_bc"
                                                        checked={checked["in_bc"]}
                                                        onChange={() => {
                                                            toggleCheck('in_bc', setFieldValue);
                                                        }}
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td></td>
                                                <td><img src={toAbsoluteUrl("/media/platforms/wordpress.png")} alt="" title="Wordpress" height="32" width="32"></img></td>
                                                <td>Wordpress</td>
                                                <td>
                                                    <Switch
                                                        name="in_wp"
                                                        checked={checked["in_wp"]}
                                                        onChange={() => {
                                                            toggleCheck('in_wp', setFieldValue);
                                                        }}
                                                    />
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <button
                                        type='submit'
                                        style={{ display: "none" }}
                                        // ref={btnRef}
                                        onSubmit={() => handleSubmit()}>
                                    </button>

                                </Form>
                            </>
                        )}
                    </Formik>

                </CardBody>
            </Card>

        </div>
    )
}
